// import React, { useState, useRef, memo, useEffect } from "react";
// import classes from "./DFileUpload.module.css";

// const DFileUpload = ({
//   onFileUpload,
//   label,
//   fileName,
//   type,
//   value,
//   containerClassName,
//   customFileTypeText,
//   customClassNameForInput,
//   disabled,
//   onChange,
//   error,
//   fileTypes,
//   errorMsg,
//   customClassName,
//   size,
// }) => {
//   const [isDragOver, setIsDragOver] = useState(false);
//   const [selectedFileName, setSelectedFileName] = useState(
//     value ? value.name : null
//   );
//   const [fileInputKey, setFileInputKey] = useState(0);
//   const fileInputRef = useRef(null);

//   const handleDragOver = (e) => {
//     e.preventDefault();
//     setIsDragOver(true);
//   };

//   const handleDragLeave = () => {
//     setIsDragOver(false);
//   };

//   const handleDrop = (e) => {
//     e.preventDefault();
//     setIsDragOver(false);
//     const file = e?.dataTransfer?.files[0];
//     onFileUpload(file);
//     setSelectedFileName(file?.name);
//   };

//   const handleBrowseClick = () => {
//     fileInputRef.current.click();
//   };

//   const handleFileInputChange = (e) => {
//     const file = e.target.files[0];
//     onFileUpload(file);
//     setSelectedFileName(file?.name);
//   };

//   useEffect(() => {
//     if (value && value.name) {
//       setSelectedFileName(value.name);
//     } else {
//       setSelectedFileName(null);
//     }
//     setFileInputKey((prevKey) => prevKey + 1);
//   }, [value]);

//   return (
//     <div className={`${classes.fileUploadWrapper} ${containerClassName}`}>
//       <div
//         className={`${classes.file_upload} ${
//           isDragOver ? classes.drag_over : ""
//         } ${disabled ? classes.diabledField : ""} ${customClassName}`}
//         style={{ width: `${size}` }}
//         onDragOver={handleDragOver}
//         onDragLeave={handleDragLeave}
//         onDrop={handleDrop}
//         disabled={disabled}
//       >
//         <label>{label}</label>
//         <label className={classes.DocText}>
//           {selectedFileName ? (
//             <span>{selectedFileName}</span>
//           ) : fileName ? (
//             <span>{fileName}</span>
//           ) : (
//             <span>Drag and drop file here </span>
//           )}
//           <input
//             key={fileInputKey}
//             type="file"
//             onChange={handleFileInputChange}
//             ref={fileInputRef}
//             style={{ display: "none" }}
//             accept={fileTypes}
//           />
//           <p>{customFileTypeText || "Upload here"}</p>
//         </label>
//         <button onClick={handleBrowseClick}>Browse</button>
//       </div>
//       {error && <p className={classes.error_message}>{errorMsg}</p>}
//     </div>
//   );
// };

// export default memo(DFileUpload);
import React, { useState, useRef, memo, useEffect } from "react";
import classes from "./DFileUpload.module.css";
import {
  DOCUMENT_UPLOAD_ACCEPT,
  DOCUMENT_UPLOAD_FORMAT_LABEL,
} from "../../../utils/documentUploadTypes";

const DFileUpload = ({
  onFileUpload,
  label,
  fileName,
  type,
  value,
  containerClassName,
  customFileTypeText,
  customClassNameForInput,
  disabled,
  onChange,
  error,
  fileTypes,
  errorMsg,
  customClassName,
  size,
}) => {
  const [isDragOver, setIsDragOver] = useState(false);
  const [selectedFileName, setSelectedFileName] = useState(
    value ? value.name : null
  );
  const [isExistingFileCleared, setIsExistingFileCleared] = useState(false);
  const [fileInputKey, setFileInputKey] = useState(0);
  const fileInputRef = useRef(null);

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragOver(true);
  };

  const handleDragLeave = () => {
    setIsDragOver(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragOver(false);
    const file = e?.dataTransfer?.files[0];
    onFileUpload(file);
    setSelectedFileName(file?.name);
    setIsExistingFileCleared(false);
  };

  const handleBrowseClick = () => {
    fileInputRef.current.click();
  };

  const handleFileInputChange = (e) => {
    const file = e.target.files[0];
    onFileUpload(file);
    setSelectedFileName(file?.name);
    setIsExistingFileCleared(false);
  };

  const handleClearClick = () => {
    onFileUpload(null);
    setSelectedFileName(null);
    setIsExistingFileCleared(true);
    handleReset();
  };

  const handleReset = () => {
    fileInputRef.current.value = null;
  };

  useEffect(() => {
    if (value && value.name) {
      setSelectedFileName(value.name);
    } else {
      setSelectedFileName(null);
    }
    setFileInputKey((prevKey) => prevKey + 1);
  }, [value]);

  useEffect(() => {
    setIsExistingFileCleared(false);
  }, [fileName]);

  const hasVisibleFile = Boolean(
    selectedFileName || (fileName && !isExistingFileCleared)
  );
  const displayFileName =
    selectedFileName || (!isExistingFileCleared ? fileName : "");

  return (
    <div className={`${classes.fileUploadWrapper} ${containerClassName}`}>
      <div
        className={`${classes.file_upload} ${
          isDragOver ? classes.drag_over : ""
        } ${disabled ? classes.diabledField : ""} ${customClassName}`}
        style={{ width: `${size}` }}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        disabled={disabled}
      >
        <label>{label}</label>
        <label className={classes.DocText}>
          {displayFileName ? (
            <span>{displayFileName}</span>
          ) : (
            <span>Drag and drop file here </span>
          )}
          <input
            key={fileInputKey}
            type="file"
            onChange={handleFileInputChange}
            ref={fileInputRef}
            style={{ display: "none" }}
            accept={fileTypes || DOCUMENT_UPLOAD_ACCEPT}
          />
          <p>{customFileTypeText || `(Supported: ${DOCUMENT_UPLOAD_FORMAT_LABEL})`}</p>
        </label>

        {!hasVisibleFile ? (
          <button
            type="button"
            onClick={handleBrowseClick}
            className={classes.browseButton}
          >
            Browse
          </button>
        ) : (
          <button
            type="button"
            onClick={handleClearClick}
            className={classes.clearButton}
          >
            <span>Clear</span>
          </button>
        )}
      </div>
      {error && <p className={classes.error_message}>{errorMsg}</p>}
    </div>
  );
};

export default memo(DFileUpload);
